import React, { useEffect, useState, useRef } from "react";
import InputText from "./inputtext";
import useCadastro from "../../hooks/useCadastroContext";
import { NumericFormat } from "react-number-format";
import Select from 'react-select'
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();
// const optionsPatrocindores = [
//   { value: 'A3 DATA', label: 'A3 DATA' },
//   { value: 'ALVAREZ & MARSAL', label: 'ALVAREZ & MARSAL' },
//   { value: 'BARRFAB', label: 'BARRFAB' },
//   { value: 'BD-BECTON DICKINSON', label: 'BD-BECTON DICKINSON' },
//   { value: 'BIONEXO S.A.', label: 'BIONEXO S.A.' },
//   { value: 'CLICKNURSE', label: 'CLICKNURSE' },
//   { value: 'CLOUD SAUDE', label: 'CLOUD SAUDE' },
//   { value: 'CUSHMAN & WAKEFIELD', label: 'CUSHMAN & WAKEFIELD' },
//   { value: 'DANONE', label: 'DANONE' },
//   { value: 'DOCTOR TIS', label: 'DOCTOR TIS' },
//   { value: 'ECOLIMP', label: 'ECOLIMP' },
//   { value: 'EY', label: 'EY' },
//   { value: 'FOLKS', label: 'FOLKS' },
//   { value: 'GETINGE DO BRASIL', label: 'GETINGE DO BRASIL' },
//   { value: 'GLOBALTHINGS', label: 'GLOBALTHINGS' },
//   { value: 'GRUPO DOC', label: 'GRUPO DOC' },
//   { value: 'GRUPO PRIME MED', label: 'GRUPO PRIME MED' },
//   { value: 'HTB ENGENHARIA', label: 'HTB ENGENHARIA' },
//   { value: 'INDIGO', label: 'INDIGO' },
//   { value: 'INOVA PHARMA', label: 'INOVA PHARMA' },
//   { value: 'INTELECTAH', label: 'INTELECTAH' },
//   { value: 'KONIMAGEM', label: 'KONIMAGEM' },
//   { value: 'LIBBS', label: 'LIBBS' },
//   { value: 'MAX EMERGENCIAS', label: 'MAX EMERGENCIAS' },
//   { value: 'META HOSPITALAR', label: 'META HOSPITALAR' },
//   { value: 'MV', label: 'MV' },
//   { value: 'NILO', label: 'NILO' },
//   { value: 'RHOPEN', label: 'RHOPEN' },
//   { value: 'RTS', label: 'RTS' },
//   { value: 'SALESFORCE', label: 'SALESFORCE' },
//   { value: 'SINCRON', label: 'SINCRON' },
//   { value: 'SISNAC', label: 'SISNAC' },
//   { value: 'SISQUAL', label: 'SISQUAL' },
//   { value: 'SOLVENTUM (3M)', label: 'SOLVENTUM (3M)' },
//   { value: 'SPECIAL GASES', label: 'SPECIAL GASES' },
//   { value: 'TELA', label: 'TELA' },
//   { value: 'TETO', label: 'TETO' },
//   { value: 'TOTVS', label: 'TOTVS' },
//   { value: 'WHITE MARTINS', label: 'WHITE MARTINS' },
//   { value: 'WOLTERS KLUWER', label: 'WOLTERS KLUWER' }
// ]

const CadastroPesquisa = () => {
  const {
    faturamento,
    setfaturamento,
    leitos,
    setleitos,
    vidas,
    setvidas,
    procura,
    setprocura,
    segmento,
    hobby,
    setHobby,
    outrosProcura,
    setOutrosProcura,
    // empresaInteresse,
    setEmpresaInteresse,
    verificaFormularioPesquisa,
    prioridade,
    setPrioridade,
    transformacao,
    setTransformacao,
    usoImagem,
    setUsoImagem,
  } = useCadastro();
  const [showOutros, setShowOutros] = useState(false);

  const [enteresses, setEnteresses] = useState([]);
  const [limiteAtingido, setLimiteAtingido] = useState(false);
  const inputProcuraRef = useRef(null);

  const handleSelectProcura = (e) => {
    if (e === "outros") {
      setShowOutros(true);
    } else {
      setShowOutros(false);
    }
    setprocura(e);
  };

  // const handleSelectInteresse = (e) => {
  //   // Limitar a seleção a no máximo 3 patrocinadores
  //   if (e && e.length > 3) {
  //     // Manter apenas os 3 primeiros selecionados
  //     const limitedSelection = e.slice(0, 3);
  //     setEnteresses(limitedSelection);
  //     setLimiteAtingido(true);
  //     let stringEmpresaInteresse = limitedSelection.map((item) => item.value).join("; ");
  //     setEmpresaInteresse(stringEmpresaInteresse);
  //   } else {
  //     setEnteresses(e);
  //     setLimiteAtingido(e && e.length === 3);
  //     let stringEmpresaInteresse = e ? e.map((item) => item.value).join("; ") : "";
  //     setEmpresaInteresse(stringEmpresaInteresse);
  //   }
  // };


  useEffect(() => {
    verificaFormularioPesquisa();
    setUsoImagem(true);
  }, []);

  // Verificar formulário sempre que qualquer campo for alterado
  useEffect(() => {
    verificaFormularioPesquisa();
  }, [procura, outrosProcura, enteresses, faturamento, leitos, vidas, prioridade, transformacao, usoImagem]);

  useEffect(() => {
    setTimeout(() => {
      scrollToTop();
      focusInputProcura();
    }, 100);
  }, [usoImagem]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
    document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const focusInputProcura = () => {
    if (inputProcuraRef.current) {
      inputProcuraRef.current.focus();
    }
  };

  const handleUsoImagem = (e) => {
    if (e.target.checked) {
      setUsoImagem(true);
    } else {
      setUsoImagem(false);
    }
  };

  return (
    <>
      <div className="area-inputs">
        <div className="mb-1">
          <label className="form-label" htmlFor="input_procura">
            O que você procura no Saúde Business Fórum?{" "}
            <span className="text-red">*</span>
          </label>
          <select
            ref={inputProcuraRef}
            className="form-select"
            aria-label="Default select example"
            id="input_procura"
            value={procura}
            onChange={(e) => handleSelectProcura(e.target.value)}
          >
            <option value="">Selecione uma opção</option>
            <option value="consultoria">Consultoria</option>
            <option value="contrucao_civil">Contrução Civil</option>
            <option value="consumiveis">Consumíveis</option>
            <option value="equipamentos">Equipamentos</option>
            <option value="facilities">Facilities</option>
            <option value="homecare">Home care</option>
            <option value="servicos">Serviços</option>
            <option value="tecnologia">Tecnologia</option>
            <option value="outros">Outros</option>
          </select>

          <input
            type="text"
            id="input_procura2"
            className="form-control form-control-lg oculto"
            placeholder="Escreva aqui..."
          />
        </div>

        {showOutros || procura === "outros" ? (
          <InputText
            label="Descrição"
            type="text"
            requered={showOutros || procura === "outros"}
            value={outrosProcura}
            onChange={setOutrosProcura}
            validador={verificaFormularioPesquisa}
          />
        ) : (
          false
        )}

        {/* <label className="form-label" htmlFor="input_procura">
          Com qual empresa você gostaria de conversar durante o evento? (máx. 3)
        </label>
        <Select
          closeMenuOnSelect={false}
          components={animatedComponents}
          isMulti
          noOptionsMessage={() => "Nenhuma empresa encontrada"}
          options={optionsPatrocindores}
          placeholder="Selecione até 3 empresas"
          onChange={(e) => handleSelectInteresse(e)}
          value={enteresses}
        /> */}

        <label htmlFor="input_faturamento" className="form-label label-input">
          Qual foi o faturamento da sua instituição em 2024?
          <span className="text-red">*</span>
        </label>
        <select
          className="form-select"
          aria-label="faturamento-label"
          id="input_faturamento"
          value={faturamento}
          onChange={(e) => setfaturamento(e.target.value)}
        >
          <option value="">Selecione uma opção</option>
          <option value="Abaixo de 1M">Abaixo de 1M</option>
          <option value="Entre 1M e 300M">Entre 1M e 300M</option>
          <option value="Entre 300M e 500M">Entre 300M e 500M</option>
          <option value="Entre 500M e 1B">Entre 500M e 1B</option>
          <option value="Entre 1B e 5B">Entre 1B e 5B</option>
          <option value="Superior a 5B">Superior a 5B</option>
        </select>

        {segmento === "hospital" ? (
          <InputText
            label="Qual o número de leitos?"
            type="number"
            requered={true}
            value={leitos}
            onChange={setleitos}
            validador={verificaFormularioPesquisa}
          />
        ) : (
          false
        )}
        {segmento === "operadora" ? (
          <InputText
            label="Qual número de vidas?"
            type="number"
            requered={true}
            value={vidas}
            onChange={setvidas}
            validador={verificaFormularioPesquisa}
          />
        ) : (
          false
        )}

        <InputText
          label="Qual é a sua prioridade de investimento para 2025/2026?"
          type="text"
          // requered={true}
          value={prioridade}
          onChange={setPrioridade}
          validador={verificaFormularioPesquisa}
        />

        <InputText
          label="Qual o maior desafio da sua instituição hoje?"
          type="text"
          // requered={true}
          value={transformacao}
          onChange={setTransformacao}
          validador={verificaFormularioPesquisa}
        />
{/* 
        <InputText
          label="Que tal nos contar um hobby ou curiosidade sua? Isso te ajudará a encontrar pessoas com o mesmo interesse e quem sabe, começar um bate-papo que resultará em grandes negócios! Se não quiser, basta colocar “não” abaixo."
          type="text"
          requered={true}
          value={hobby}
          onChange={setHobby}
          validador={verificaFormularioPesquisa}
        /> */}

        <div className="termo-aceite-container">
          <div className="termo-aceite-box">
            <div className="termo-aceite-icon">
              <i className="fas fa-camera text-primary"></i>
            </div>
            <div className="termo-aceite-content">
              <h6 className="termo-aceite-title">
                <i className="fas fa-info-circle me-2 text-info"></i>
                Autorização de Uso de Imagem
              </h6>
              <p className="termo-aceite-text">
                As <strong>fotografias e imagens do evento</strong> poderão ser usadas pela
                <strong> Informa Markets</strong> para promover o setor e o evento.
                Você autoriza expressamente, <strong>a título gratuito e definitivo</strong>,
                a utilização de sua <strong>imagem e/ou voz</strong> em qualquer material,
                impresso ou virtual, no território <strong>nacional e internacional</strong>.
              </p>
            </div>
          </div>

          <div className="termo-aceite-checkbox">
            <label htmlFor="check-termo-aceite1" className="checkbox-container">
              <input
                type="checkbox"
                name="check-termo-aceite1"
                id="check-termo-aceite1"
                checked={usoImagem}
                onChange={(e) => handleUsoImagem(e)}
                className="checkbox-input"
              />
              <span className="checkbox-custom"></span>
              <span className="checkbox-label">
                <strong>Concordo com os termos acima</strong>
              </span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};
export default CadastroPesquisa;
